import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const MesaAyudaCliente = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/formato-mesa-ayuda-cliente.pdf`;
  /*const pdfUrl = "/pdf/formato-mesa-ayuda-cliente.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Mesa de Ayuda al Cliente</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Mesa de Ayuda al Cliente" />
      </Container>
    </>
  );
};

 export default MesaAyudaCliente;
